
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
        
    color:'#fff',
    name:'Eingabe',
    showminies: true,
    showmedia: true,
    vuexnamespace: 'entities',
    initmutation:'entities/ENTITY_INIT_ENTITY',
    backlink:'entities',   
    duplicateable:true,
    helptext:"Hier werden sowohl die Rezepte als auch die Zutaten eingepflegt. Diese werden später durch eine \n\
            Kategorie (Rezept/Zutat) von einander unterschieden.<br> Pflichtfelder in diesem Formular sind das\n\
            Name Feld sowie das eben erwähnte Kategoriefeld. Die Felder Nummer, Spezifikation und Tags sind optional.<br><br>\n\
            Gespeichert wird mit dem einfachen Haken. Mit dem schwarzen Kreuz wird das Formular verlassen. <br><br>\n\
            Mit dem goldenen Doppelkaken wird ein Datensatz dupliziert. Der duplizierte Datensatz wird danach sofort\n\
            zur Bearbeitung geöffnet.<br><br> \n\
            Nach erfolgreichem Speichern öffnen sich in diesem Formular noch der Bildupload und die Eingabe der einzelnen\n\
            Rezeptschritte. <br><br>\n\
            Der Bildupload erlaubt das Hochladen mehrerer Bilder (zur Zeit auf drei begrenzt). Mit dem oberen Button wird ein neues\n\
            Bild hinzugefügt und zum Rezept/ zur Zutat gespeichert. Bereits hochgeladene Bilder tauchen darunter auf. Diese\n\
            können durch klicken und neues Bild auswählen geändert werden.<br><br>\n\
            Die etwas differenziertere 'Tageingabe' ist nach gewissen Tagkategorien voreingestellt. <br><br>\n\
            Das Formular zur Eingabe der Rezeptschritte wird mit dem weißen Plus aufgerufen. Hier können dann sämtliche\n\
            Verarbeitungsschritt relevanten Daten eingepflegt werden. <br><br>\n\
            Das Auge links neben dem Plus öffnet einen Einheitenrechner mit der Möglichkeit die Gewichtsmenge für eine Portion\n\
            sowie die Anzahl der Personen für die später gekocht werden soll einzugeben."

    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};